import * as THREE from 'three'

const placeholderMinHeight = 3
const placeholderMinWidth = 3
const placeholderMinDepth = 3

/**
 * https://discourse.threejs.org/t/round-edged-box/1402
 * @param width
 * @param height
 * @param depth
 * @param radius0
 * @param smoothness
 * @returns {ExtrudeGeometry}
 */
const createBoxWithRoundedEdges = function(width, height, depth, radius0, smoothness) {
  let shape = new THREE.Shape()
  let eps = 0.00001
  let radius = radius0 - eps
  shape.absarc(eps, eps, eps, -Math.PI / 2, -Math.PI, true)
  shape.absarc(eps, height - radius * 2, eps, Math.PI, Math.PI / 2, true)
  shape.absarc(width - radius * 2, height - radius * 2, eps, Math.PI / 2, 0, true)
  shape.absarc(width - radius * 2, eps, eps, 0, -Math.PI / 2, true)
  let geometry = new THREE.ExtrudeBufferGeometry(shape, {
    depth: depth - radius0 * 2,
    bevelEnabled: true,
    bevelSegments: smoothness * 2,
    steps: 1,
    bevelSize: radius,
    bevelThickness: radius0,
    curveSegments: smoothness
  })
  geometry.center()
  return geometry
}

const placeholderMaterial = new THREE.MeshLambertMaterial({
  color: 0x2d3d42
})

const invalidPlaceholderMaterial = new THREE.MeshLambertMaterial({
  color: 0xff0000
})

/**
 * Creates a box with rounded edges.
 * @param width
 * @param depth
 * @param height
 * @returns {Mesh}
 */
const createPlaceholder = function(width, depth, height) {
  if (height <= placeholderMinHeight) height = placeholderMinHeight
  if (width <= placeholderMinWidth) width = placeholderMinWidth
  if (depth <= placeholderMinDepth) depth = placeholderMinDepth
  let placeholderGeometry = createBoxWithRoundedEdges(width, height, depth, 1, 2)
  const placeholder = new THREE.Mesh(placeholderGeometry, placeholderMaterial)
  placeholder.castShadow = true
  return placeholder
}

export {
  createPlaceholder,
  placeholderMaterial,
  invalidPlaceholderMaterial,
  placeholderMinWidth,
  placeholderMinHeight,
  placeholderMinDepth
}

